import { useCallback, useContext, useMemo } from 'react'
import { OrgProviderContext } from '../../internal'
import { AccountDto } from '../../../../dtos/account.dto'
import { DomainDto } from '../../../../dtos/domain'

type OrgProviderApi = {
    getOrg(): AccountDto
    getDomains(): DomainDto[]
}

export const useOrgProvider = (): OrgProviderApi => {
    const ctx = useContext(OrgProviderContext)
    if (!ctx) {
        throw new Error('useOrgProvider must be used within a OrgProvider')
    }

    const { state } = ctx

    const getOrg = useCallback(() => {
        if (!state.org) {
            throw new Error('Org not loaded')
        }
        return state.org
    }, [state.org])

    const getDomains = useCallback(() => state.domains ?? [], [state.domains])

    return useMemo(
        () => ({
            getOrg,
            getDomains,
        }),
        [getOrg, getDomains],
    )
}
